import React from 'react';
import cls from 'classnames';
export default function Button(_a) {
    var color = _a.color, size = _a.size, _b = _a.loading, loading = _b === void 0 ? false : _b, style = _a.style, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, children = _a.children;
    var className = cls('button', color && "is-".concat(color), size && "is-".concat(size), loading && 'is-loading');
    return (React.createElement("button", { className: className, style: style, disabled: disabled, onClick: onClick }, children));
}
